import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { tigardConfig } from "./data";

export default function TigardPage() {
  return <OregonCityPageTemplate config={tigardConfig} />;
}